import { render } from "./NewWeekView.vue?vue&type=template&id=be2b7dbc"
import script from "./NewWeekView.vue?vue&type=script&lang=js"
export * from "./NewWeekView.vue?vue&type=script&lang=js"

import "./NewWeekView.vue?vue&type=style&index=0&id=be2b7dbc&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__